<template>
    <!-- 成功提示 -->
    <div class="success-box txt-center">
        <p>
            <img src="../../assets/img/register-icon-fail.png">
        </p>
        <p class="tip" v-if="tip">{{tip}}</p>
        <p class="title">{{title}}</p>
        <p class="btn-box">
            <btn-large @click="$emit('failFn')">{{btnTxt}}</btn-large>
        </p>
    </div>
</template>
<script>
    export default {
        props:['title','tip','btnTxt']
    }
</script>
<style lang="less" scoped>
    .success-box{
        width:30rem;
        margin:0 auto;
        padding:4.5rem 0 .8rem;
        border-bottom: .05rem solid #EFEFEF;
        p.tip{
            padding:.5rem 0 .5rem;
            color:#666; 
        }
        p.title{
            font-size: 1rem; 
            font-weight: bold;
        }
        p:last-child{
            padding:1.3rem 0 1.5rem;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/BaseCpts/resultFail.vue